import React from "react";

import Design from "./designs/Design";
import { AdvancedTabsGroupTemplatesContainer, DesignContainer } from "./styles";
import { useAdvancedTabsGroupStore } from "../../../../../../../stores/use-advanced-tabs-group-store";
import { useOpticsStore } from "../../../../../../../stores/use-optics-store";
import { getAdvancedTabsGroupTemplates } from "./advanced-tabs-group-templates";

const AdvancedTabsGroupTemplates = () => {
  const { data, setData, selectedTab, setSelectedTab } =
    useAdvancedTabsGroupStore((state) => ({
      data: state.data,
      setData: state.setData,
      selectedTab: state.selectedTab,
      setSelectedTab: state.setSelectedTab,
    }));

  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const hasData = !!Object.keys(data).length;
  const templates = getAdvancedTabsGroupTemplates(styleguideSetup);

  return (
    <AdvancedTabsGroupTemplatesContainer>
      {templates.map((template) => (
        <DesignContainer
          onClick={() => {
            if (hasData) {
              setData({
                ...data,
                style: template.style,
              });
            } else {
              setData(template);
            }
            setDrawers({ templates: false, settings: true });
          }}
        >
          <Design
            data={template}
            isPreview
            tab={{ selectedTab, setSelectedTab }}
          />
        </DesignContainer>
      ))}
    </AdvancedTabsGroupTemplatesContainer>
  );
};

export default AdvancedTabsGroupTemplates;
